<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="row mb-3">
      <label class="col text-primary fw-semibold fs-6">ตรวจสอบและอนุมัติข้อมูลการคำนวน POINT</label>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-borderless mb-0 caption-top">
            <thead>
            <tr>
              <th scope="col">รอบที่</th>
              <th scope="col">เดือน</th>
              <th scope="col">สถานะการพิจารณา</th>
              <th scope="col">สถานะการประมวลผล</th>
              <th scope="col" class=" text-end">เวลาที่ใช้ (นาที)</th>
              <th scope="col" class=" text-end">จำนวนผู้มีสิทธิ UC ทั้งหมด</th>
              <th scope="col" class=" text-end">จำนวนผู้มีสิทธิ DIS ทั้งหมด</th>
              <th scope="col" class=" text-end">จำนวนผู้มีสิทธิทั้งหมด</th>
            </tr>
            </thead>
            <tbody>
              @if (job()) {
                <tr>
                  <td>{{ job().roundText }}</td>
                  <td>{{ job().monthly }}</td>
                  <td>
                    <app-point-job-status [status]="job().status"></app-point-job-status>
                  </td>
                  <td>{{ job().processStatus }} - {{ ProcessStatus[job().processStatus] }}</td>
                  <td class="text-end fs-5 fw-semibold text-muted">{{ (job().elapsedMinute | number) || 'N/A' }}</td>
                  <td class="text-end fs-4 fw-semibold text-success">{{ (job().totalUc | number) || '0' }}</td>
                  <td class="text-end fs-4 fw-semibold text-success">{{ (job().totalDis | number) || '0' }}</td>
                  <td class="text-end fs-4 fw-semibold text-success">{{ (job().total | number) || '0' }}</td>
                </tr>
                <tr>
                  <td class="" colspan="8">
                    <ngb-progressbar [type]="job()?.processStatus != 'E'? 'primary': 'danger'"
                                     [value]="job().progPercent || 0" [striped]="true" [animated]="true">
                      <i>{{ job().progPercent }}%</i>
                    </ngb-progressbar>
                    <div class="form-text">{{ job().progression }}</div>
                  </td>
                </tr>
              } @else {
                <tr>
                  <td colspan="8">
                    <app-not-found></app-not-found>
                  </td>
                </tr>
              }
            </tbody>
            <tfoot>
            <tr>
              <td colspan="4">
                <div class="mb-3">
                  <span class="fw-semibold">สถานะการทำงาน</span>
                  ประมวลผล Point
                  @if (job()?.status == 'P' || job()?.status == 'W') {
                    <span class="bi bi-check-circle-fill text-success mx-1"></span>
                  } @else if (job()?.status == 'E') {
                    <span class="bi bi-x-circle-fill text-danger mx-1"></span>
                  } @else if (job()?.status == 'I' || job()?.status == 'R') {
                    [กำลังประมวลผล..]
                    <span class="bi bi-question-circle-fill text-primary mx-1"
                          style="color: rgb(58 87 232 / 20%);"></span>
                  } @else {
                    <span class="bi bi-question-circle-fill mx-1" style="color: rgb(58 87 232 / 20%);"></span>
                  }
                  ......
                  สร้างไฟล์ .mdb
                  @if (job()?.reportStatus == 'P') {
                    <span class="bi bi-check-circle-fill text-success mx-1"></span>
                  } @else if (job()?.reportStatus == 'E') {
                    <span class="bi bi-x-circle-fill text-danger mx-1"></span>
                  } @else if (job()?.reportStatus == 'I') {
                    [กำลังสร้างไฟล์..]
                    <span class="bi bi-question-circle-fill text-primary mx-1"
                          style="color: rgb(58 87 232 / 20%);"></span>
                  } @else {
                    <span class="bi bi-question-circle-fill mx-1" style="color: rgb(58 87 232 / 20%);"></span>
                  }
                  ......
                  ย้ายข้อมูลไป _HIS
                  @if (job()?.moveHisStatus == 'P') {
                    <span class="bi bi-check-circle-fill text-success mx-1"></span>
                  } @else if (job()?.moveHisStatus == 'E') {
                    <span class="bi bi-x-circle-fill text-danger mx-1"></span>
                  } @else if (job()?.moveHisStatus == 'I') {
                    [กำลังย้ายข้อมูลไปลง _HIS...]
                    <span class="bi bi-question-circle-fill mx-1"
                          style="color: rgb(58 87 232 / 20%);"></span>
                  } @else {
                    <span class="bi bi-question-circle-fill mx-1" style="color: rgb(58 87 232 / 20%);"></span>
                  }
                </div>
              </td>
              <td class="text-end" colspan="4">
                @if (job()) {
                  @if (job().reportStatus == 'I') {
                    <button class="btn btn-custom btn-default me-2" type="button" disabled>
                      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                      <span role="status">กำลังส่งออกไฟล์ Access...</span>
                    </button>
                  } @else {
                    @if (!job().mdbFile && job()?.status == 'W') {
                      <button (click)="regenerateFile()" type="button" class="btn btn-custom btn-default mx-2">
                        <i class="bi bi-1-circle me-2"></i>สร้างไฟล์ Access
                      </button>
                    }
                    @if ((job().status != 'E') && job().mdbFile) {
                      <button (click)="downloadFileMdb()" type="button" class="btn btn-default mx-2">
                        ดาวน์โหลด
                        <i class="bi text-primary bi-file-earmark-zip-fill ms-2"></i>
                      </button>
                    }
                  }
                  @if ((job().status != 'E') && !!job().mdbFile) {
                    <button (click)="sentEmailPoint()" type="button" class="btn btn-custom btn-default me-2">
                      <i class="bi bi-2-circle me-2"></i>ส่งอีเมล
                    </button>
                  }
                  @if (job().status == 'W' && !job().approveStatus) {
                    <button (click)="approve()" type="button" class="btn btn-custom btn-success">
                      <i class="bi bi-3-circle me-2"></i>อนุมัติ และย้ายข้อมูล
                    </button>
                  } @else if (job().approveStatus == 'I') {
                    <button class="btn btn-custom btn-default" type="button" disabled>
                      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                      <span role="status">กำลังอนุมัติ และย้ายข้อมูล...</span>
                    </button>
                  } @else if (job().approveStatus == 'P') {
                    <span class="text-success fw-semibold">
                      <i class="bi bi-3-circle me-2"></i>อนุมัติ และย้ายข้อมูลแล้ว
                    </span>
                  } @else if (job().approveStatus == 'E') {
                    <button (click)="approve()" type="button" class="btn btn-custom btn-danger">
                      <i class="bi bi-3-circle me-2"></i>อนุมัติ ไม่สำเร็จ
                    </button>
                  }
                  <!--                  @if (job().status == 'P') {-->
                    <!--                    @if (job().reportStatus == 'P') {-->
                    <!--                      <button [disabled]="!job().mdbFile" (click)="downloadFileMdb()" type="button"-->
                    <!--                              class="btn btn-primary mx-2">-->
                    <!--                        ดาวน์โหลดไฟล์ .mdb-->
                    <!--                      </button>-->
                    <!--                      <button (click)="sentEmailPoint()" type="button" class="btn btn-outline-primary">-->
                    <!--                        จัดส่งอีเมล-->
                    <!--                      </button>-->
                    <!--                    } @else if (job().reportStatus == 'E') {-->
                    <!--                      <span class="text-danger fw-semibold">สร้างไฟล์ไม่สำเร็จ</span>-->
                    <!--                      <button (click)="regenerateFile()" type="button" class="btn btn-custom btn-outline-danger">-->
                    <!--                        สร้างไฟล์ใหม่อีกครั้ง-->
                    <!--                      </button>-->
                    <!--                    }-->
                    <!--                    @if (job().status == 'P' && !job().moveHisStatus) {-->
                    <!--                      <button (click)="moveResultToHis()" type="button" class="btn btn-custom btn-outline-primary ms-2">-->
                    <!--                        <i class="bi bi-boxes me-1"></i>ย้ายข้อมูล-->
                    <!--                      </button>-->
                    <!--                    }-->
                    <!--                    @if (job().moveHisStatus == 'E') {-->
                    <!--                      <button (click)="moveResultToHis()" type="button" class="btn btn-custom btn-outline-danger ms-2">-->
                    <!--                        <i class="bi bi-boxes me-1"></i> ย้ายข้อมูลอีกครั้ง-->
                    <!--                      </button>-->
                    <!--                    }-->
                    <!--                  } @else if (job().status == 'W') {-->
                    <!--                    <button (click)="approve()" type="button" class="btn btn-custom btn-success">-->
                    <!--                      อนุมัติ-->
                    <!--                    </button>-->
                    <!--                  }-->
                }
              </td>
            </tr>
            <tr>
              <td colspan="4">

              </td>
              <td class="text-danger text-end" colspan="4">
                หมายเหตุ: กรุณากดปุ่ม "อนุมัติ และย้ายข้อมูล" ก่อนประมวลผล Point รอบถัดไป
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <div class="row my-3">
      <label class="col text-primary fw-semibold fs-6">Check List ตรวจสอบเงื่อนไขอัตโนมัติโดยระบบ</label>
    </div>
    <app-point-checklist-table [checklist]="job()?.checklist"></app-point-checklist-table>
    @if (job()?.status == 'W' || job()?.status == 'E') {
      <div class="row g-3">
        <div class="col-12">
          <button (click)="callJob()" type="button" class="btn btn-danger">
            คำนวน POINT ใหม่
          </button>
          <!--        @if (job()?.status == 'W' || job()?.status == 'P') {-->
          <!--          <button (click)="notImplementedYet()" type="button" class="btn btn-outline-primary float-end ms-2">-->
          <!--            รายงานสรุปภาพรวม-->
          <!--          </button>-->
          <!--          <button (click)="notImplementedYet()" type="button" class="btn btn-outline-primary float-end">-->
          <!--            รายงานสรุปรายหน่วย-->
          <!--          </button>-->
          <!--        }-->
        </div>
        <label class="col-12">
          หมายเหตุ : กรณีคำนวน Point ใหม่สถานะจะเปลี่ยนเป็น "อยู่ระหว่างการประมวลผลใหม่"
        </label>
      </div>
    }
  </div>
</div>
